<template>
  <div id="app">
    <vue-progress-bar></vue-progress-bar>
    <transition name="fade" mode="out-in">
      <router-view :key="$route"></router-view>
    </transition>
    <navigation></navigation>
  </div>
</template>

<script>
  import navigation from '@/components/Navigation';
  
  export default {
    name: 'app',
    components: { navigation },
    data() {
      return {
        title: 'Kalenji by Decathlon',
      };
    },
    head: {
      title() {
        return {
          inner: this.title,
          separator: '–',
        };
      },
      meta() {
        return [
          { name: 'description', content: '' },
        ];
      },
    },
    created() {
      window.vm = this;
      this.$store.commit('hideCart');
    },
    mounted() {
      if (this.$cookie.get('basket')) {
        this.$store.state.cart = JSON.parse(this.$cookie.get('basket'));
      }
    },
  };
</script>

<style lang="scss">
  @import './styles/global';
</style>



// WEBPACK FOOTER //
// App.vue?28de1e18